import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { HttpClient } from '@angular/common/http';
import { User } from '../User';
import { AlertService } from '../alert.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-vehicle-documents',
  templateUrl: './vehicle-documents.component.html',
  styleUrls: ['./vehicle-documents.component.scss']
})
export class VehicleDocumentsComponent implements OnInit {

  private user: User = new User();

  custData: Observable<any>;


  public detail: any = [];
  public ongoingData: any = [];
  public getCompDetail: any = [];
  public serviceRequestData: any = [];
  //getServiceRequest
  private debugData: Boolean = true; // to show and hide the data in console log
  otpErrorMsg: string = ""; // to display the error msg on otp popup
  mobileverifyMsg: string = ""; //shows msg mobile verified or not

  constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService, private apiService: ApiService,
    private httpClient: HttpClient, private alertService: AlertService,private sanitizer: DomSanitizer) {

    this.initCustData();
  }
  ngOnInit() {

  }

  initCustData() {
    if (this.apiService.checkUserLoggedIn() == true) {
      let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
      this.httpClient.get(urrr)
        .subscribe(
          data => this.intilizeComponent(data),
          error => this.showError(error)
        );

    } else {
      console.log("User Not Logged In. Please login!")
    }

  }

  intilizeComponent(data) {
    console.log("under inti comp");
    this.user = data;
    this.getOngoing();

    if (this.user.mobileVerified == 0) {
      this.mobileverifyMsg = "mobile not verified";
    }
    else {
      this.mobileverifyMsg = "mobile verified";
    }
  }

  showError(msg) {
    console.log("Error Found in server");
  }

  refresh(): void {
    window.location.reload();
  }

  //public custdd = this.apiService.getFromLocalData('custDD');
  getOngoing() {
    if (this.debugData) {
      console.log("OnGoing FUnction : ");
    }
    let getData = { "customer": this.user.id }
    this.httpClient.post(this.apiService.ongoingBooking, getData)
      .subscribe(
        (jdetail: any) => {
          if (this.debugData) {
            console.log("OnGoing API Data: ");
            console.log(jdetail);
          }
          this.ongoingData = jdetail;
        }
      )
  }

  isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
  }








}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/vehicle-documents/vehicle-documents.component.ts